import HeaderPersonal from "../../components/funcionarios/HeaderPersonal";
import Flag from "../../components/funcionarios/Flag";
import Motivo from "../../components/funcionarios/Motivo";
import {
  Container,
  Col,
  Row,
  Form,
  Button,
  Pagination,
  Card,
  Stack,
} from "react-bootstrap";
import {
  getHistorial,
  agregarComentario,
} from "../../services/apis_funcionarios";
import { useEffect, useState, useMemo } from "react";
import TarjetaHistorial from "../../components/funcionarios/TarjetaHistorial";

const styles = {
  container: {
    backgroundColor: "var(--color-background-3)",
    height: "100%",
    width: "100%",
  },
  fechaTitulo: {
    color: "var(--color-text-muted)",
  },
};

// -------------------------
// FIX FECHAS SIN DESFASE
// -------------------------
function parseFecha(fechaStr) {
  const [y, m, d] = fechaStr.split("-").map(Number);
  return new Date(y, m - 1, d); // ← evita UTC y evita desfase
}

function formatearFecha(fechaStr) {
  const fecha = parseFecha(fechaStr);
  return fecha.toLocaleDateString("es-CL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

function Historial() {
  const [funcionarioId, setFuncionarioId] = useState(null);
  const [loadingFuncionario, setLoadingFuncionario] = useState(true);

  const [historial, setHistorial] = useState([]);
  const [loadingHistorial, setLoadingHistorial] = useState(false);

  // Filtros
  const [soloFlagsTrue, setSoloFlagsTrue] = useState(false); // ← NUEVO
  const [filtroFecha, setFiltroFecha] = useState("hoy");

  // Paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const itemsPorPagina = 20;

  // obtener funcionario
  useEffect(() => {
    const API_URL = (import.meta?.env?.VITE_API_URL || "").replace(/\/$/, "");
    fetch(`${API_URL}/api/me/`, { credentials: "include" })
      .then(async (res) => {
        if (!res.ok) throw new Error(`API /me/ status ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data?.funcionario?.id) setFuncionarioId(data.funcionario.id);
      })
      .catch((err) => console.error("Error obteniendo funcionario:", err))
      .finally(() => setLoadingFuncionario(false));
  }, []);

  // cargar historial
  const cargarHistorial = async () => {
    if (!funcionarioId) return;
    try {
      setLoadingHistorial(true);
      const data = await getHistorial(funcionarioId);
      setHistorial(data.atenciones || []);
    } catch (error) {
      console.error("Error cargando historial:", error);
    } finally {
      setLoadingHistorial(false);
    }
  };

  useEffect(() => {
    cargarHistorial();
  }, [funcionarioId]);

  // editar comentario
  const handleEditComentario = async (nuevoComentario, idAtencion) => {
    try {
      await agregarComentario(idAtencion, { comentario: nuevoComentario });
      await cargarHistorial();
    } catch (error) {
      console.error("Error editando:", error);
    }
  };

  const handleFlagChange = (idS, nuevoValor) => {
    setHistorial((prev) =>
      prev.map((at) =>
        at.user.idS === idS
          ? { ...at, user: { ...at.user, flag: nuevoValor } }
          : at
      )
    );
  };


  // -------------------------
  //   FILTROS
  // -------------------------
  const atencionesFiltradas = useMemo(() => {
    let lista = [...historial];

    // Filtro Flag con checkbox
    if (soloFlagsTrue) {
      lista = lista.filter((a) => a.user?.flag === true);
    }

    // Filtro fecha
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const ayer = new Date(hoy);
    ayer.setDate(hoy.getDate() - 1);

    lista = lista.filter((a) => {
      const fecha = parseFecha(a.fecha);
      fecha.setHours(0, 0, 0, 0);

      switch (filtroFecha) {
        case "hoy":
          return fecha.getTime() === hoy.getTime();

        case "ayer":
          return fecha.getTime() === ayer.getTime();

        case "semana": {
          const inicioSemana = new Date(hoy);
          const day = hoy.getDay();
          const diff = day === 0 ? 6 : day - 1;
          inicioSemana.setDate(hoy.getDate() - diff);
          inicioSemana.setHours(0, 0, 0, 0);

          return fecha >= inicioSemana && fecha <= hoy;
        }

        case "mes":
          return (
            fecha.getMonth() === hoy.getMonth() &&
            fecha.getFullYear() === hoy.getFullYear()
          );

        default:
          return true;
      }
    });

    return lista;
  }, [historial, soloFlagsTrue, filtroFecha]);

  // paginación
  const totalPaginas = Math.ceil(atencionesFiltradas.length / itemsPorPagina);
  const inicio = (paginaActual - 1) * itemsPorPagina;

  const atencionesPagina = atencionesFiltradas.slice(
    inicio,
    inicio + itemsPorPagina
  );

  useEffect(() => setPaginaActual(1), [soloFlagsTrue, filtroFecha]);

  // agrupar por fecha
  const agrupadoPorFecha = useMemo(() => {
    const grupos = {};

    atencionesPagina.forEach((a) => {
      const fechaFormateada = formatearFecha(a.fecha);

      if (!grupos[fechaFormateada]) grupos[fechaFormateada] = [];
      grupos[fechaFormateada].push(a);
    });

    return grupos;
  }, [atencionesPagina]);

  if (loadingFuncionario) {
    return <p className="text-center mt-5">Cargando funcionario...</p>;
  }

  return (
    <Container fluid className="p-0 m-0 w-100">
      <Row className="g-3">
        <Col xs={12}>
          <Container
            fluid
            className="rounded p-4 shadow-sm border"
            style={styles.container}
          >
            {/* FILTROS */}
            <Row className="mb-1">
              <Col xs={12}>
                <p className="h3 mb-3">Historial de atenciones</p>
              </Col>
              <Col xs="auto">
                {/* CONTADOR */}
                <p className="my-0 text-muted" style={{ whiteSpace: "nowrap" }}>
                  {atencionesFiltradas.length} resultados
                </p>
              </Col>
              <Col className="ms-auto" xs="auto">
                <Row className="g-3 justify-content-end">
                  <Col xs="auto">
                    <Form.Check
                      type="checkbox"
                      label="Solo Flags Activos"
                      checked={soloFlagsTrue}
                      onChange={(e) => setSoloFlagsTrue(e.target.checked)}
                      size="sm"
                    />
                  </Col>
                  <Col xs="auto">
                    <Form.Select
                      value={filtroFecha}
                      onChange={(e) => setFiltroFecha(e.target.value)}
                      size="sm"
                      style={{ width: "150px" }}
                    >
                      <option value="todas">Todas</option>
                      <option value="hoy">Hoy</option>
                      <option value="ayer">Ayer</option>
                      <option value="semana">Esta semana</option>
                      <option value="mes">Este mes</option>
                    </Form.Select>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* TARJETAS */}
            <Row>
              <Col xs={12}>
                {Object.keys(agrupadoPorFecha).length === 0 ? (
                  <p className="text-center pt-3 m-0 text-muted">
                    No hay atenciones
                  </p>
                ) : (
                  Object.keys(agrupadoPorFecha).map((fecha, index) => (
                    <div key={fecha}>
                      <hr />
                      <div
                        className="my-2 fs-6 fw-semibold"
                        style={styles.fechaTitulo}
                      >
                        {fecha}
                      </div>
                      <Stack gap={2}>
                        {agrupadoPorFecha[fecha].map((a) => (
                          <TarjetaHistorial
                            key={a.id}
                            atencion={a}
                            handleEditComentario={handleEditComentario}
                            onChangeFlag={handleFlagChange}
                          />
                        ))}
                      </Stack>
                    </div>
                  ))
                )}
              </Col>
            </Row>

            {/* PAGINACIÓN */}
            {totalPaginas > 0 && (
              <Row className="mt-4">
                <Col className="d-flex justify-content-center">
                  <Pagination className="primary-pagination">
                    {Array.from({ length: totalPaginas }, (_, i) => (
                      <Pagination.Item
                        key={i + 1}
                        active={i + 1 === paginaActual}
                        onClick={() => setPaginaActual(i + 1)}
                      >
                        {i + 1}
                      </Pagination.Item>
                    ))}
                  </Pagination>
                </Col>
              </Row>
            )}
          </Container>
        </Col>
      </Row>
    </Container>
  );
}

export default Historial;
